/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-08-12 10:42:52
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-22 09:52:33
 */
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import _ from 'lodash'
import { api, sendAsync } from '../../app/applicationSlice'
import { RootState, RootThunkApi } from '../../app/store'
import * as T from '../../services/transactionQuery'

interface TransactionQuerying {
  exportTag: []
  exportLoading: false
}

const initialState: TransactionQuerying = {
  exportTag: [],
  exportLoading: false,
}

const transactionQuerySlice = createSlice({
  name: 'transactionQuerySlice',
  initialState,
  reducers: {
    setExportTag(state, action) {
      state.exportTag = action.payload
    },
    setExportLoading(state, action) {
      state.exportLoading = action.payload
    },
  },
})

export const { setExportTag, setExportLoading } = transactionQuerySlice.actions

export const selectExportTag = (state: RootState) =>
  state.transactionQuerys.exportTag

export const selectExportLoading = (state: RootState) =>
  state.transactionQuerys.exportLoading

export const getTransactionQueryList = createAsyncThunk<
  void,
  T.TransactionQueryListParams,
  RootThunkApi
>('payment/getTransactionQueryList', async (params, api) => {
  return sendAsync(T.transactionQueryList(params), api)
})

export const getTransactionDetailQueryList = createAsyncThunk<
  void,
  T.TransactionQueryDetailListParams,
  RootThunkApi
>('payment/getTransactionDetailQueryList', async (params, api) => {
  return sendAsync(T.transactionDetailQueryList(params), api)
})

export const getTransactionQueryTotal = createAsyncThunk<
  void,
  T.TransactionQueryListParams,
  RootThunkApi
>('payment/getTransactionQueryTotal', async (params, api) => {
  return sendAsync(T.transactionQueryTotal(params), api)
})

export const getTransactionDetailQueryTotal = createAsyncThunk<
  void,
  T.TransactionQueryDetailListParams,
  RootThunkApi
>('payment/getTransactionDetailQueryTotal', async (params, api) => {
  return sendAsync(T.transactionDetailQueryTotal(params), api)
})

//导出
export const getTransactionDetailQueryExport = createAsyncThunk<
  void,
  T.TransactionQueryDetailListParams,
  RootThunkApi
>('doctorAudit/getTransactionDetailQueryExport ', async (params, api) => {
  return sendAsync(T.transactionDetailQueryExport(params), api)
})


// 保存列
export const getSubmitPageColumnListAsync = createAsyncThunk<
  void,
  T.SubmitPageColumnListParams,
  RootThunkApi
>('payment/getSubmitPageColumnListAsync', async (params, api) => {
  return sendAsync(T.getSubmitPageColumnList(params), api)
})

// 获取列
export const getPageColumnListAsync = createAsyncThunk<
  void,
  T.PageColumnListParams,
  RootThunkApi
>('payment/getPageColumnListAsync', async (params, api) => {
  return sendAsync(T.getPageColumnList(params), api)
})

//导出
export const getTransactionQueryExport = createAsyncThunk<
  void,
  T.TransactionQueryListParams,
  RootThunkApi
>('doctorAudit/getTransactionQueryExport ', async (params, api) => {
  return sendAsync(T.transactionQueryExport(params), api)
})
export default transactionQuerySlice.reducer
